import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import '../../teacherTests.css';
import '../../../../diagnosticReporting/DiagnosticStyles.css'
import React, {useContext, useRef, useState, useEffect, useMemo} from "react";
import {Checkbox, Divider, Form, Select, Space, Table} from "antd";
import Card from "../../../../common/Card";
import Button from "../../../../common/Button";
import {ErrorOutline, ExpandLess, ExpandMore} from "@mui/icons-material";
import {STEP_NUMBERS} from "./Data";
import axios from "../../../../common/axios";
import {UserContext} from "../../../../common/UserContext";
import {BrandContext} from "../../../../common/BrandContext";
import useCurrentConcept from "../../../../hooks/useCurrentConcept";
import Tooltip from "../../../../common/Tooltip";
import HelpIcon from "@mui/icons-material/Help";
import {GRID_ENUMS} from "../../../../diagnosticReporting/Styles.js";
import ArrowLeftIcon from "../../../../common/icons/ArrowLeftIcon";

const AssignedFollowUpWork = (props) => {
    const brandConfig = useContext(BrandContext);

    const {stepChange, testAssignmentData} = props,
        ALL_CLASSES = 'ALL_CLASSES',
        MY_CLASSES = 'MY_CLASSES';

    const [classSearchForm] = Form.useForm(),
        [studentData, setStudentData] = useState([]),
        [studentRawData, setStudentRawData] = useState(null),
        [teacherStudentRawData, setTeacherStudentRawData] = useState(null),
        [allStudents, setAllStudents] = useState([]),
        [teacherStudents, setTeacherStudents] = useState([]),
        [studentIds, setStudentIds] = useState([]),
        [allStudentIds, setAllStudentIds] = useState([]),
        [teacherStudentIds, setTeacherStudentIds] = useState([]),
        [selectedStudentIds, setSelectedStudentIds] = useState([]),
        [skillResourceData, setSkillResourceData] = useState([]),
        [studentResultsMap, setStudentResultsMap] = useState({}),
        [isTableLoading, setIsTableLoading] = useState(true),
        [classComment, setClassComment] = useState(''),
        [expandedRowKeys, setExpandedRowKeys] = useState([]),
        {user} = useContext(UserContext),
        {loadCurrentConcept} = useCurrentConcept(),
        teacherClassIds = user.classes.map((elem) => {
            return elem.classId
        }),
        skillResourceSelectTableRef = useRef(),
        rowHeight = 30;


    const studentColumns = {
            Student:{title:'Student', key:'student', dataIndex:'student'},
            Performance:{title:'Performance on test', key:'performance', dataIndex:'performance',
                render: (value) => {
                    return <div className="ch-center-elem">{value}</div>;
                }},
            Work:{
                title: (
                    <span>{brandConfig.diagnosticFeedbackName}<Tooltip
                        title={(
                            <div><p>This is the work that has been assigned to students based on this test.</p><p>{brandConfig.diagnosticFeedbackName} will be
                                displayed to students as suggested revision.</p></div>
                        )}
                        placement="top">
                    <HelpIcon style={{
                        verticalAlign: 'middle',
                        marginLeft: '4px',
                        width: '16px',
                        height: '16px'
                    }}/>
                    </Tooltip></span>
                ), key:'followUp', dataIndex:'followUp',
            },
            TaskDueDate:{
                title:'Task due date',
                key:'taskDueDate',
                dataIndex:'taskDueDate'
                // render: (_, record) => {
                //     return <div className="ch-center-elem">{record.taskDueDate}</div>;
                // }
            },
            StudentComment:{
                title: 'Individual comment',
                key: 'comment',
                dataIndex: 'comment',
                width: '40%'
                // render: (_, record) => {
                //     return <div className="ch-center-elem">{record.comment}</div>;
                // }
            }
        },
        skillResourceColumns = {
            Skill:{title:'Mathematical skills', key:'skill', dataIndex:'skill',
            render:(val,record,idx)=>{return skillResourceRender(val,record,idx)}},
            PercentCorrect:{title:'%', key:'percentCorrect', dataIndex:'percentCorrect',width:100, align:'center'},
            Section: {
                title: 'Revisit this section from your textbook',
                key: 'section', dataIndex: 'section', align: 'left',
                render: (val, record, idx) => {
                    return skillResourceRender(val, record, idx)
                }
            },
            Video: {
                title: () => {
                    return 'Watch these worked example videos'
                },
                key: 'video', dataIndex: 'video', align: 'left',
                render: (val, record, idx) => {
                    return skillResourceRender(Object.assign({}, val, {video: true}), record, idx)
                }
            },
            Walkthrough: {
                title: () => {
                    return 'See how you go with these'
                },
                key: 'walkthrough', dataIndex: 'walkthrough', align: 'left',
                render: (val, record, idx) => {
                    return skillResourceRender(val, record, idx)
                }
            },
            Exercise: {
                title: 'For more practice, do these exercise questions',
                key: 'exercise', dataIndex: 'exercise', align: 'left',
                render: (val, record, idx) => {
                    return skillResourceRender(val, record, idx)
                }
            }
        }

    const getSkillResourceMediaId = (tutorialId) => {
        axios.get('/web/media/tutorial/' + tutorialId)
            .then((response) => {
                openVideoDialog(response.data);
            }).catch((error) => {
                console.error('Error loading skill resource video: ',error);
            });
    }

    const getSkillResourceTabHash = (conceptId, skillResourceId) => {
        axios.get('/web/ui/tab/skillResource/' + skillResourceId)
            .then((response) => {
                if (response.data) {
                    // console.log('response.data.hashName',response.data.hashName)
                    loadCurrentConcept(conceptId, response.data.hashName);
                }
            }).catch((error) => {
                console.error('Error loading concept with tab hash: ',error);
            });
    }

    const handleLoadSkillResource = (val) => {
        if (val.video && val.tutorialId) {
            getSkillResourceMediaId(val.tutorialId);
        } else {
            if (val.resourceType === 'CONCEPT') {
                loadCurrentConcept(val.conceptId);
            } else {
                getSkillResourceTabHash(val.conceptId, val.skillResourceId);
            }
        }
    }

    const skillResourceRender = (val) => {
        const {textLink = '', link = false, className = link ? 'ch-link' : ''} = val;

        if (!link) {
            return (<span>{textLink}</span>);
        }

        return (<Button type="text" className={className} onClick={() => handleLoadSkillResource(val)}>{textLink}</Button>);
    }

    const studentColumnsData = [];
    for(const [key,value] of Object.entries(studentColumns)){
        studentColumnsData.push(value);
    }

    const skillResourceColumnsData = [];
    for(const [key,value] of Object.entries(skillResourceColumns)){
        skillResourceColumnsData.push(value);
    }

    useEffect(() => {
        getSkillResourceData();
    }, []);

    useEffect(() => {
        if (skillResourceData.length > 0) {
            loadSkillResultsAndSkillResources();
        }
        // setIsTableLoading(false);
    }, [skillResourceData]);

    useEffect(() => {
        if (studentRawData !== null) {
            const tempTeacherStudentRawData = [],
                tempAllStudents = [],
                tempTeacherStudents = [],
                allIds = [],
                teacherIds = [];

            studentRawData.forEach((testResult) => {
                // console.log('testResult.feedbackDueDate',testResult.feedbackDueDate);
                const student = {
                    userId: testResult.userId,
                    name: testResult.lastName + ', ' + testResult.firstName,
                    taskDueDate: testResult.feedbackDueDate ? user.dateFormat.format(testResult.feedbackDueDate) : GRID_ENUMS.NOT_AVAILABLE,
                    comment: testResult.feedbackMessage ? testResult.feedbackMessage : ''
                }
                tempAllStudents.push(student);
                allIds.push(testResult.userId);
                if (testResult.classIds.some(classId => teacherClassIds.includes(classId))) {
                    tempTeacherStudentRawData.push(testResult);
                    tempTeacherStudents.push(student);
                    teacherIds.push(testResult.userId);
                }
            });

            setTeacherStudentRawData(tempTeacherStudentRawData);
            setAllStudents(tempAllStudents);
            setTeacherStudents(tempTeacherStudents);
            setStudentIds(allIds);
            setTeacherStudentIds(teacherIds);
            setAllStudentIds(allIds);
            setSelectedStudentIds(allIds);

            setStudentData(generateStudentData(studentRawData, tempAllStudents));

            classSearchForm.setFieldsValue({['studentIds']: allIds});
        }
    }, [studentRawData]);

    const loadSkillResultsAndSkillResources = () => {
        setIsTableLoading(() => {
            return true;
        });
        // console.log('getTestAssignmentTestResultsWithSkillAverage');
        // console.log('testAssignmentId: ',testAssignmentId);
        // console.log('classIds: ',classIds);

        const classIds = testAssignmentData.classes.map((clazz) => {return clazz.classId;});

        axios.get('/web/ui/test/getTestAssignmentTestResultsWithSkillMarks',
            {params: {testAssignmentId: testAssignmentData.testAssignmentId, populateSkillResources: true}})
            .then((response) => {
                // loadStudents(response.data);
                setStudentRawData(response.data);
                setIsTableLoading(false);
            }).catch((error)=>{
                setIsTableLoading(false);
                console.error('Error test results with skills: ',error);
        });
    }

    const getSkillResourceData = ()=>{
        axios.get('/web/ui/test/getTestAssignmentConceptSkillResources',{params:{testAssignmentId: testAssignmentData.testAssignmentId}})
            .then((response)=>{
                // console.log('response.data: ',response.data);
                setSkillResourceData(response.data);
            }).catch((error)=>{
            displayToastMessage('Error getting skill resources.', '', 'error', 10000);
            console.error('Error getting skill resources: ',error);
        });
    }

    const RESOURCE_TYPE = {
        VIDEO:'video',
        SECTION:'section',
        WALKTHROUGH:'walkthrough',
        EXERCISE:'exercise'
    }

    const skillResourceColIndexes = {
        Skill:'skill',
        PercentCorrect:'percentCorrect',
        Section:RESOURCE_TYPE.SECTION,
        Video:RESOURCE_TYPE.VIDEO,
        Walkthrough:RESOURCE_TYPE.WALKTHROUGH,
        Exercise:RESOURCE_TYPE.EXERCISE
    }

    const generateStudentData = (studentResultData, studentList) => {
        // console.log('data: ',data);
        // console.log('studentSkillResourceIds : ',studentSkillResourceIds);
        // console.log('dummyStudents : ',dummyStudents);

        // console.log('studentResultData: ',studentResultData);

        const studentSkillScores = {},
            studentResourceSkills = {},
            studentTestScores = {},
            studentSkillResourcesAmount = {};

        if(studentResultData.length > 0){
            setClassComment(studentResultData[0].classFeedbackMessage);
        }

        studentResultData.forEach((testResult)=>{
            const skillResultsMap = {},
                skillResourceResultsMap = {},
                studentTestScoreMap = {testScore: testResult.startDate ? testResult.percentCorrect + '%' : GRID_ENUMS.NOT_AVAILABLE};
            testResult.testResultSkills.forEach((result) => {
                skillResultsMap[result.skillId] = result.markPercent;
            });
            studentSkillScores[testResult.userId] = skillResultsMap;
            studentTestScores[testResult.userId] = studentTestScoreMap;

            if(testResult.hasOwnProperty('skillResourceIds')){
                testResult.skillResourceIds.forEach((skillResourceId)=>{
                    skillResourceResultsMap[String(skillResourceId)] = {included:true};
                });
                studentResourceSkills[testResult.userId] = skillResourceResultsMap;
                studentSkillResourcesAmount[testResult.userId] = {skillResourcesChosen: testResult.skillResourceIds.length};
            }
        });

        const skillResourceMapData = {};
        const studentData = [];

        studentList.forEach((student) => {
            let row = {name: student.name, key: String(student.userId), id: student.userId};
            const skills = [];
            let studentRowData = [];
            let skillResourcesChecked = 0;

            // for (const [conceptKey, conceptValue] of Object.entries(skillResourceData)) {
            skillResourceData.forEach((concept) => {
                // console.log('conceptKey: ',conceptKey);
                // console.log('conceptValue: ',conceptValue);
                let conceptRow = {titleHighlight: true, rowSpan: 6, isConcept: true};
                conceptRow[skillResourceColIndexes.Skill] = {textLink: concept.conceptName};
                // conceptRow[skillResourceColIndexes.PercentCorrect.dataIndex] = student.score+'%';
                // conceptRow[skillResourceColIndexes.PercentCorrect] = 'add later %';
                conceptRow[skillResourceColIndexes.Section] = {};
                conceptRow[skillResourceColIndexes.Video] = {};
                conceptRow[skillResourceColIndexes.Walkthrough] = {};
                conceptRow[skillResourceColIndexes.Exercise] = {};
                let setConcept = true;

                concept.reviewConcepts.forEach((reviewConcept) => {
                    if(setConcept){
                        conceptRow.conceptId = reviewConcept.conceptId;
                        conceptRow.key = reviewConcept.conceptId;
                        setConcept = false;
                    }
                    let skillResourceRow =
                        {
                            key:reviewConcept.conceptId+'-'+reviewConcept.skillId,
                            isSkill:true
                        };
                    if(studentSkillScores.hasOwnProperty(String(student.userId)) && studentSkillScores[student.userId].hasOwnProperty(String(reviewConcept.skillId))){
                        skillResourceRow[skillResourceColIndexes.PercentCorrect] = studentSkillScores[student.userId][reviewConcept.skillId]+'%';
                    }else{
                        skillResourceRow[skillResourceColIndexes.PercentCorrect] = GRID_ENUMS.NOT_AVAILABLE;
                    }

                    let rowLinkCnt = 0;

                    reviewConcept.skillResources.forEach((skillResource)=>{
                        const skillResourceObj = {
                            skillResourceId: skillResource.skillResourceId,
                            conceptId: skillResource.conceptId,
                            resourceType: skillResource.resourceType,
                            link: studentResourceSkills.hasOwnProperty(student.userId) && studentResourceSkills[student.userId].hasOwnProperty(String(skillResource.skillResourceId)) && studentResourceSkills[student.userId][String(skillResource.skillResourceId)].included
                        };

                        if (skillResourceObj.link) {
                            rowLinkCnt++;
                            if(skillResource.resourceType === 'CONCEPT'){
                                skillResourceObj.textLink = skillResource.textbookConceptName;
                                skillResourceRow[skillResourceColIndexes.Section] = skillResourceObj;
                            }else if(skillResource.resourceType === 'QUESTION'){
                                if(skillResource.questionType === 'WALKTHROUGH'){
                                    skillResourceObj.textLink = 'Now You Try '+skillResource.resourceNumber;
                                    skillResourceRow[skillResourceColIndexes.Walkthrough] = skillResourceObj;
                                }
                            }else if(skillResource.resourceType === 'QUESTION_CLUSTER'){
                                skillResourceObj.textLink = skillResource.resourceNumber+': '+skillResource.resourceSubNumbers;
                                skillResourceRow[skillResourceColIndexes.Exercise] = skillResourceObj;
                            }else if(skillResource.resourceType === 'TUTORIAL' && skillResource.tutorialSubType === 'EXAMPLE'){
                                skillResourceObj.textLink = 'Example '+skillResource.resourceNumber;
                                skillResourceObj.tutorialId = skillResource.tutorialId;
                                skillResourceRow[skillResourceColIndexes.Video] = skillResourceObj;
                            }
                        }

                        // skillResourceRow[skillResourceColumns.PercentCorrect.dataIndex] = score+'%';
                        // skillResourceRow[skillResourceColumns.PercentCorrect.dataIndex] = score+'%';

                        // let questionsNum = randomInt(1,6);
                        // skillResourceRow[skillResourceColumns.Exercise.dataIndex] = {textLink:(questionsNum) +', ' + (questionsNum+1) + ', ' + (questionsNum+2) , checked:randomBoolean(),checkboxType:CHECKBOX_TYPES.SINGLE_RESOURCE};
                        // skills.push(skill);
                    });
                    Object.values(skillResourceColIndexes).forEach((value)=>{
                        if(value !== skillResourceColIndexes.PercentCorrect && value !== skillResourceColIndexes.Skill && !skillResourceRow.hasOwnProperty(value)){
                            skillResourceRow[value] = {textLink:GRID_ENUMS.NOT_AVAILABLE,link:false};
                        }
                    });

                    skillResourceRow[skillResourceColIndexes.Skill] = {textLink:reviewConcept.skillName}

                    if (rowLinkCnt > 0) {
                        if (!studentRowData.includes(conceptRow)) {
                            studentRowData.push(conceptRow);
                        }
                        studentRowData.push(skillResourceRow);
                    }
                });
            });

            row.expandable = studentRowData.length > 0;

            row[studentColumns.Student.dataIndex] = student.name;
            // console.log('studentTestScores[student.userId].testScore: ',studentTestScores[student.userId].testScore);
            row[studentColumns.Performance.dataIndex] = studentTestScores[student.userId].testScore;
            // console.log('studentTestScores: ',studentTestScores);
            // console.log('student.comment: ',student.comment);
            row[studentColumns.StudentComment.dataIndex] = student.comment;
            row[studentColumns.TaskDueDate.dataIndex] = student.taskDueDate;
            row[studentColumns.Work.dataIndex] = (studentSkillResourcesAmount.hasOwnProperty(student.userId) && studentSkillResourcesAmount[student.userId].hasOwnProperty('skillResourcesChosen') ? studentSkillResourcesAmount[student.userId].skillResourcesChosen : 'No') + ' skill resources';

            row.expanded = false;

            studentData.push(row);
            skillResourceMapData[student.userId] = {studentData: studentRowData};
        });
        setStudentResultsMap(skillResourceMapData);
        return studentData;
    }

    const filterAssignedFollowupWork = () => {
        let searchFieldValues = classSearchForm.getFieldsValue(),
            searchByClass = searchFieldValues.searchByClass,
            searchStudentIds = searchFieldValues.studentIds,
            filteredStudentData = searchByClass === ALL_CLASSES ? [...studentRawData] : [...teacherStudentRawData],
            tempStudentList = searchByClass === ALL_CLASSES ? allStudents.filter(student => searchStudentIds.includes(student.userId)) : teacherStudents.filter(student => searchStudentIds.includes(student.userId)),
            tempSearchIds = searchByClass === ALL_CLASSES ? allStudentIds.filter(id => searchStudentIds.includes(id)) : teacherStudentIds.filter(id => searchStudentIds.includes(id));

        filteredStudentData = filteredStudentData.filter((testResult) => tempSearchIds.includes(testResult.userId));

        classSearchForm.setFieldsValue({['studentIds']: tempSearchIds});
        setStudentData(generateStudentData(filteredStudentData, tempStudentList));

    }

    const onResultExpand = (record) => {
        setIsTableLoading(true);
        // console.log('record.key: ',record.key);
        if (record.expanded) {
            collapseRow(record.id);
            record.expanded = false;
        } else {
            expandRow(record.id);
            record.expanded = true;
        }
        setIsTableLoading(false);
    }

    const expandRow = (studentId, testData) => {
        studentData.forEach((row) => {
            if (parseInt(row.id) === parseInt(studentId)) {
                row.expanded = true;
                if (!expandedRowKeys.includes(studentId)) {
                    setExpandedRowKeys([...expandedRowKeys, String(studentId)]);
                }
            }
        });
    }

    const collapseRow = (studentId) => {
        studentData.forEach((row) => {
            if (row.id === studentId) {
                row.expanded = false;
                setExpandedRowKeys(expandedRowKeys.filter((key) => key !== String(studentId)));
            }
        });
    }

    const backToAssignFollowUpWork = () => {
        stepChange(STEP_NUMBERS.TEST_ASSIGNMENTS.number);
    }

    const handleClassesChange = value => {
        let searchFieldValues = classSearchForm.getFieldsValue(),
            tempSearchIds,
            tempSelectedIds;

        if (value === ALL_CLASSES) {
            tempSearchIds = allStudentIds.filter(id => searchFieldValues.studentIds.includes(id));
            if (tempSearchIds.length === 0) tempSearchIds = [...allStudentIds];
            tempSelectedIds = [...allStudentIds];
        } else {
            tempSearchIds = teacherStudentIds.filter(id => searchFieldValues.studentIds.includes(id));
            if (tempSearchIds.length === 0) tempSearchIds = [...teacherStudentIds];
            tempSelectedIds = [...teacherStudentIds];
        }

        setSelectedStudentIds(tempSelectedIds);

        classSearchForm.setFieldsValue({['studentIds']: tempSearchIds});
    }

    const handleStudentChange = value => {
        setStudentIds(value);
    }

    const handleSelectAllChange = event => {
        if (event.target.checked) {
            setStudentIds(allStudentIds);
            classSearchForm.setFieldsValue({['studentIds']: selectedStudentIds});
        } else {
            clearStudentSelect();
        }
    }

    const clearStudentSelect = () => {
        classSearchForm.setFieldsValue({['studentIds']: []});
        setStudentIds([]);
    }

    return (
        <>
            <div>
                <Space className="flex" direction="horizontal" size="middle"
                       style={{width: '100%', margin: '12px 4px 6px 4px', justifyContent: 'space-between'}}>
                    <h2>Assigned {brandConfig.diagnosticFeedbackName.toLowerCase()} ({testAssignmentData.testName})</h2>
                    <Button type="outline" onClick={backToAssignFollowUpWork}><ArrowLeftIcon/> Back to assign {brandConfig.diagnosticFeedbackName.toLowerCase()}</Button>
                </Space>
                <Space direction="vertical" size="middle" style={{display: 'flex', justifyContent: 'space-between'}}>
                    <Card id="studentResultSearchBox" rounded={false}>
                        <h4>Filter</h4>
                        <Form
                            id="classSearchForm"
                            form={classSearchForm}
                            initialValues={{
                                searchByClass: ALL_CLASSES,
                                studentIds: allStudentIds
                            }}
                            layout="vertical"
                            style={{display:'flex', gap:'12px'}}
                        >
                            <Form.Item
                                name="searchByClass"
                                label="Search by"
                                style={{width: '200px'}}
                            >
                                <Select virtual={false} showSearch={false} showarrow={'true'} onChange={handleClassesChange} getPopupContainer={trigger => trigger.parentElement}>
                                    <Select.Option key={ALL_CLASSES} value={ALL_CLASSES}>All classes</Select.Option>
                                    <Select.Option key={MY_CLASSES} value={MY_CLASSES}>My classes</Select.Option>
                                </Select>
                            </Form.Item>
                            <Form.Item
                                label="Student"
                                name="studentIds"
                                style={{width: '300px'}}
                            >
                                <Select virtual={false} showSearch={false} showarrow={'true'} popupRender={menu => (
                                    <div>
                                        {menu}
                                        <Divider style={{margin: '0 0 4px 0'}}/>
                                        <div style={{padding: '4px'}}>
                                            <Checkbox disabled={allStudentIds.length === 0} value={studentIds}
                                                      defaultChecked={true}
                                                      checked={studentIds.length === allStudentIds.length}
                                                      onChange={handleSelectAllChange}>Select all students</Checkbox>
                                        </div>
                                    </div>
                                )} allowClear autoClearSearchValue={true}
                                    // onSelect={handleStudentSelect} onDeselect={handleStudentDeselect}
                                        onChange={handleStudentChange}
                                    // onClear={handleStudentClear}
                                        mode="multiple" maxTagCount="responsive"
                                        getPopupContainer={trigger => trigger.parentElement}>
                                    {allStudents.map((student) => {
                                        return <Select.Option key={student.userId} disabled={(!selectedStudentIds.includes(student.userId))}
                                                              value={student.userId}>{student.name}</Select.Option>;
                                    })}
                                </Select>
                            </Form.Item>
                            <div className="flex" style={{alignItems: 'end', marginBottom: '3px'}}><Button onClick={filterAssignedFollowupWork}>Filter</Button></div>
                        </Form>
                    </Card>
                    <Card rounded={false} style={{minHeight:'1000px'}}>
                        <Space direction="vertical" size="middle" style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <p><span className="ch-bold ch-med-font">Comment for students:&nbsp;</span>{classComment ? classComment : <span style={{fontWeight:'italic',color:'lightgrey'}}>no comment was set.</span>}</p>
                        </Space>
                        <div className="flex padding-b--m" style={{justifyContent:'space-between'}}>
                            <Table id="skillResources" className="ch-general-table-antd"
                                   ref={skillResourceSelectTableRef}
                                   // pagination={{defaultCurrent: 1, current:currentPage, onChange:onPageChange, pageSize: pageSize}}
                                   // rowSelection={{selectedRowKeys, checkStrictly:false,
                                   //     onChange: onSelectChange, onSelect: onRowSelect, onSelectAll: onSelectAllRows,
                                   //     getCheckboxProps: (record) => ({
                                   //         // disabled: record.type === 'Shared',
                                   //         // Column configuration not to be checked
                                   //         name: record.name,
                                   //     })}}
                                   rowClassName={(record) => (record.expandable ? 'ch-expandable-row' : 'ch-non-expandable-row')}
                                   expandable={{
                                       expandedRowKeys: expandedRowKeys,
                                       expandRowByClick: true,
                                       rowExpandable: (record) => {return record.expandable},
                                       onExpand: (e, record) => {onResultExpand(record)},
                                       expandedRowRender: (record) => {
                                           return (
                                               <Table className="ch-general-table-antd"
                                                      rowClassName={(record, index) => record.titleHighlight ? 'row-title-highlight' : ''}
                                                      columns={skillResourceColumnsData}
                                                      pagination={false}
                                                      dataSource={studentResultsMap[record.key].studentData} />
                                           );
                                       },
                                       expandIcon: ({ expanded, record }) => {
                                           return (
                                               !record.expandable ? <></> :
                                               expanded ? (
                                                   <ExpandLess style={{width: '24px', height: '24px', cursor: 'pointer'}} onClick={() => onResultExpand(record)}/>
                                               ) : (
                                                   <ExpandMore style={{width: '24px', height: '24px', cursor: 'pointer'}} onClick={() => onResultExpand(record)}/>
                                               )
                                           )
                                       }
                                   }}
                                   size={'middle'}
                                   columns={studentColumnsData}
                                   dataSource={studentData}
                                   loading={isTableLoading}
                                   // rowClassName={() => 'editable-row'}
                                   // components={{
                                   //     body: {
                                   //         row: EditableRow,
                                   //         cell: EditableCell
                                   //     },
                                   // }}
                            />
                        </div>
                    </Card>
                </Space>
            </div>
        </>
    )
}
export default AssignedFollowUpWork;
